import { render, staticRenderFns } from "./displacement.vue?vue&type=template&id=067850ac&scoped=true"
import script from "./displacement.vue?vue&type=script&lang=js"
export * from "./displacement.vue?vue&type=script&lang=js"
import style0 from "./displacement.vue?vue&type=style&index=0&id=067850ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067850ac",
  null
  
)

export default component.exports